module.exports = __webpack_public_path__ + "img/IMG_0652.ba634aa9.png";